var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.hidden ? _c('div', {
    staticClass: "d-contents"
  }, [!_vm.isOpened ? _c('div', {
    class: [_vm.$style.surveyRiderContainer, _vm.shouldAddMargin ? _vm.$style.extraMarginTop : ''],
    on: {
      "click": _vm.startSurvey
    }
  }, [_c('MottoIcon', {
    class: _vm.$style.squareIcon,
    attrs: {
      "name": "SquareStar",
      "icon-color": "orange"
    }
  })], 1) : _vm._e(), _vm.isOpened ? _c('div', {
    class: [_vm.$style.surveyContent, _vm.shouldAddMargin ? _vm.$style.extraMarginTop : '']
  }, [_c('div', {
    class: _vm.$style.title
  }, [_c('p', [_vm._v(_vm._s(_vm.surveyQuestion.title))])]), _vm.submitted ? [_vm._m(0)] : [_vm._l(_vm.surveyQuestion.questions, function (question) {
    return _c('div', {
      key: question.id
    }, [question.type === 'default' ? _c('div', {
      class: _vm.$style.surveyDefault
    }, [_c('p', {
      staticClass: "p1 font-weight-bold"
    }, [_vm._v(_vm._s(question.body))]), _c('BaseInputText', {
      attrs: {
        "textarea": ""
      },
      model: {
        value: _vm.surveyAnswers[question.id],
        callback: function callback($$v) {
          _vm.$set(_vm.surveyAnswers, question.id, $$v);
        },
        expression: "surveyAnswers[question.id]"
      }
    })], 1) : _vm._e(), question.type === 'rating' ? _c('div', {
      class: _vm.$style.surveyStar
    }, [_c('p', {
      staticClass: "p1 font-weight-bold"
    }, [_vm._v(_vm._s(question.body))]), _c('SurveyStarRating', {
      attrs: {
        "least-star-description": question.lowestRatingDescription,
        "most-star-description": question.highestRatingDescription
      },
      on: {
        "star-rating": function starRating(star) {
          _vm.updateStarRating(question.id, star);
        }
      }
    })], 1) : _vm._e(), question.type === 'multiple' ? _c('div', {
      class: _vm.$style.surveyMultiple
    }, [_c('p', {
      staticClass: "p1 font-weight-bold"
    }, [_vm._v(_vm._s(question.body))]), _vm._l(question.responseOptions, function (response) {
      return _c('BaseRadioButton', {
        key: "".concat(response.id).concat(response.surveyQuestionId),
        attrs: {
          "theme": "simple",
          "label": response.option,
          "name": "".concat(response.surveyQuestionId),
          "value": response.id
        },
        model: {
          value: _vm.surveyAnswers[question.id],
          callback: function callback($$v) {
            _vm.$set(_vm.surveyAnswers, question.id, $$v);
          },
          expression: "surveyAnswers[question.id]"
        }
      });
    })], 2) : _vm._e()]);
  }), _c('div', {
    class: _vm.$style.buttons
  }, [_c('BaseButton', {
    attrs: {
      "theme": "orange"
    },
    on: {
      "click": _vm.dismissSurvey
    }
  }, [_vm._v("Dismiss")]), _c('BaseButton', {
    attrs: {
      "theme": "orange",
      "disabled": _vm.noQuestionsAnswered || _vm.submitting
    },
    on: {
      "click": _vm.submitSurvey
    }
  }, [_vm.submitting ? [_c('LoaderIcon')] : [_vm._v("Submit")]], 2)], 1)]], 2) : _vm._e()]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex h-100 w-100 mt-3 align-items-center justify-content-center"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("Thank you for your feedback!")])]);
}]

export { render, staticRenderFns }